import { useQuery } from '@tanstack/react-query';

import { listNotifications, unreadNotificationCount } from '../../lib/api/endpoints';

export const notificationKeys = {
  all: ['notifications'] as const,
  list: (filters: { unread?: boolean; limit?: number }) =>
    [...notificationKeys.all, 'list', filters] as const,
  unreadCount: () => [...notificationKeys.all, 'unread-count'] as const,
};

export function useNotifications(filters: { unread?: boolean; limit?: number } = {}) {
  return useQuery({
    queryKey: notificationKeys.list(filters),
    queryFn: () => listNotifications(filters),
  });
}

export function useUnreadCount() {
  return useQuery({
    queryKey: notificationKeys.unreadCount(),
    queryFn: unreadNotificationCount,
  });
}
